<template>
  <!--
    NewPassword.vue — mesma linguagem visual do SignIn.
    Wrapper .signin-page aplica o gradiente + ícones SVG de fundo.
    O .form-signin original é mantido intacto como card central.
  -->
  <div class="signin-page" role="main" aria-label="Tela de alteração de senha">
    <!-- Ícones de saúde decorativos — aria-hidden, pointer-events:none -->
    <svg
      class="signin-page__bg-icons"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1440 900"
      preserveAspectRatio="xMidYMid slice"
    >
      <!-- Cruz grande — topo direito -->
      <g transform="translate(1270,60) rotate(15)" opacity="0.07">
        <rect x="-8" y="-28" width="16" height="56" rx="4" fill="white" />
        <rect x="-28" y="-8" width="56" height="16" rx="4" fill="white" />
      </g>

      <!-- Prancheta — meio esquerdo -->
      <g transform="translate(55,340) rotate(-8)" opacity="0.06">
        <rect
          x="0"
          y="8"
          width="44"
          height="54"
          rx="4"
          fill="none"
          stroke="white"
          stroke-width="2.5"
        />
        <rect x="14" y="2" width="16" height="12" rx="3" fill="white" />
        <line
          x1="8"
          y1="26"
          x2="36"
          y2="26"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="8"
          y1="34"
          x2="36"
          y2="34"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="8"
          y1="42"
          x2="28"
          y2="42"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </g>

      <!-- Pílula/cápsula — topo esquerdo -->
      <g transform="translate(80,100) rotate(-30)" opacity="0.06">
        <rect
          x="0"
          y="0"
          width="52"
          height="22"
          rx="11"
          fill="none"
          stroke="white"
          stroke-width="2.5"
        />
        <line x1="26" y1="0" x2="26" y2="22" stroke="white" stroke-width="2" />
        <rect
          x="0"
          y="0"
          width="26"
          height="22"
          rx="11"
          fill="white"
          opacity="0.2"
        />
      </g>

      <!-- Estetoscópio — inferior direito -->
      <g transform="translate(1180,610) rotate(10)" opacity="0.055">
        <circle
          cx="20"
          cy="10"
          r="12"
          fill="none"
          stroke="white"
          stroke-width="2.5"
        />
        <path
          d="M10 20 Q-4 40 10 58 Q24 72 24 88"
          fill="none"
          stroke="white"
          stroke-width="2.5"
          stroke-linecap="round"
        />
        <circle
          cx="24"
          cy="96"
          r="8"
          fill="none"
          stroke="white"
          stroke-width="2.5"
        />
      </g>

      <!-- Cruz pequena — meio direito -->
      <g transform="translate(1350,430) rotate(-10)" opacity="0.05">
        <rect x="-5" y="-18" width="10" height="36" rx="3" fill="white" />
        <rect x="-18" y="-5" width="36" height="10" rx="3" fill="white" />
      </g>

      <!-- Seringa — inferior esquerdo -->
      <g transform="translate(30,640) rotate(20)" opacity="0.06">
        <rect
          x="12"
          y="0"
          width="32"
          height="14"
          rx="3"
          fill="none"
          stroke="white"
          stroke-width="2"
        />
        <line
          x1="28"
          y1="14"
          x2="28"
          y2="32"
          stroke="white"
          stroke-width="3"
          stroke-linecap="round"
        />
        <line x1="23" y1="32" x2="33" y2="32" stroke="white" stroke-width="2" />
        <line
          x1="28"
          y1="32"
          x2="28"
          y2="42"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
        <line
          x1="0"
          y1="7"
          x2="12"
          y2="7"
          stroke="white"
          stroke-width="2"
          stroke-linecap="round"
        />
      </g>

      <!-- Assinatura/rubrica — topo centro -->
      <g transform="translate(600,28) rotate(-5)" opacity="0.05">
        <path
          d="M0 28 C10 8,24 0,34 12 C44 24,34 42,48 36 C62 28,68 14,78 18"
          fill="none"
          stroke="white"
          stroke-width="2.5"
          stroke-linecap="round"
        />
        <line
          x1="10"
          y1="42"
          x2="72"
          y2="42"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
          opacity="0.6"
        />
      </g>

      <!-- Coração — inferior centro-direito -->
      <g transform="translate(920,730) rotate(-8)" opacity="0.055">
        <path
          d="M24 44 C24 44,0 28,0 14 C0 5,7 0,14 0 C19 0,24 5,24 5 C24 5,29 0,34 0 C41 0,48 5,48 14 C48 28,24 44,24 44Z"
          fill="white"
        />
      </g>

      <!-- Pílula pequena — direito superior -->
      <g transform="translate(1120,240) rotate(45)" opacity="0.045">
        <rect
          x="0"
          y="0"
          width="38"
          height="17"
          rx="8"
          fill="none"
          stroke="white"
          stroke-width="2"
        />
        <line
          x1="19"
          y1="0"
          x2="19"
          y2="17"
          stroke="white"
          stroke-width="1.5"
        />
      </g>

      <!-- Termômetro — esquerdo inferior-médio -->
      <g transform="translate(190,530) rotate(-15)" opacity="0.05">
        <rect
          x="8"
          y="0"
          width="14"
          height="44"
          rx="7"
          fill="none"
          stroke="white"
          stroke-width="2"
        />
        <circle
          cx="15"
          cy="56"
          r="10"
          fill="none"
          stroke="white"
          stroke-width="2"
        />
        <rect
          x="11"
          y="22"
          width="8"
          height="24"
          rx="4"
          fill="white"
          opacity="0.4"
        />
      </g>

      <!-- Cruz grande — inferior esquerdo (parcialmente cortada) -->
      <g transform="translate(-10,780) rotate(5)" opacity="0.04">
        <rect x="-10" y="-40" width="20" height="80" rx="5" fill="white" />
        <rect x="-40" y="-10" width="80" height="20" rx="5" fill="white" />
      </g>

      <!-- Prancheta pequena — topo direito médio -->
      <g transform="translate(850,18) rotate(12)" opacity="0.045">
        <rect
          x="0"
          y="7"
          width="34"
          height="44"
          rx="3"
          fill="none"
          stroke="white"
          stroke-width="2"
        />
        <rect x="11" y="1" width="12" height="10" rx="2" fill="white" />
        <line
          x1="7"
          y1="22"
          x2="27"
          y2="22"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <line
          x1="7"
          y1="30"
          x2="27"
          y2="30"
          stroke="white"
          stroke-width="1.5"
          stroke-linecap="round"
        />
      </g>
    </svg>

    <!-- Card do formulário — mantém .form-signin global intacto -->
    <b-container class="form-signin signin-page__card">
      <b-row>
        <b-col cols="12" class="mt-0 pt-0">
          <img
            id="logo"
            src="https://sistemclinupload.s3.amazonaws.com/logo.png"
            alt="Sistema Clin — Software para ILPI, casas de repouso e clínicas"
          />
        </b-col>
      </b-row>
      <request-code
        v-if="page == 'request-code'"
        :timeoutMessage="timeoutMessage"
        @recover-with-code="page = 'recover-with-code'"
        @requested="evOnCodeRequested"
      />
      <recover-with-code
        v-if="page == 'recover-with-code'"
        :timeoutMessage="timeoutMessage"
        @request-code="page = 'request-code'"
        @token-received="evOnTokenReceived"
      />
      <recover-with-token
        v-if="page == 'recover-with-token'"
        :timeoutMessage="timeoutMessage"
        :email="email"
        :token="token"
        @canceled="evOnTokenCanceled"
        @recovered="evOnPasswordRecovered"
      />
      <errors-messages :errors="errors" />
    </b-container>
  </div>
</template>

<script>
import api from "../services/api";
import RequestCode from "../templates/NewPassword/RequestCode.vue";
import RecoverWithCode from "../templates/NewPassword/RecoverWithCode.vue";
import RecoverWithToken from "../templates/NewPassword/RecoverWithToken.vue";
import ErrorsMessages from "../templates/Components/ErrorsMessages.vue";

export default {
  name: "NewPassword",
  components: {
    RequestCode,
    RecoverWithToken,
    RecoverWithCode,
    ErrorsMessages,
  },
  data() {
    return {
      errors: [],
      loading: false,
      page: "request-code",
      timeoutHandler: {},
      timeout: 0,
      timeoutMessage: "",
      token: "",
      email: "",
    };
  },
  created() {
    this.usingToken();
  },
  methods: {
    async usingToken() {
      this.token = this.$router.history.current.params.token;
      if (this.token) await this.proceedWithToken();
    },

    async proceedWithToken() {
      try {
        this.loading = true;
        let params = { token: this.token };
        let response = await api.get("/rest-home/user/new-password", {
          params,
        });
        let { error, errors, email } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.email = email;
          this.page = "recover-with-token";
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async evOnCodeRequested() {
      this.timeout = 10;
      this.timeoutMessage = `Um código foi enviado em seu e-mail. Aguarde ${this.timeout} segundos para ser redirecionado.`;
      this.timeoutHandler = setInterval(() => {
        this.timeout--;
        this.timeoutMessage = `Um código foi enviado em seu e-mail. Aguarde ${this.timeout} segundos para ser redirecionado.`;
        if (this.timeout <= 0) {
          clearInterval(this.timeoutHandler);
          this.timeoutMessage = "";
          this.page = "recover-with-code";
        }
      }, 1000);
    },

    async evOnTokenReceived(email, token) {
      this.timeout = 5;
      this.timeoutMessage = `Código validado, aguarde ${this.timeout} segundos para ser redirecionado.`;
      this.timeoutHandler = setInterval(() => {
        this.timeout--;
        this.timeoutMessage = `Código validado, aguarde ${this.timeout} segundos para ser redirecionado.`;
        if (this.timeout <= 0) {
          clearInterval(this.timeoutHandler);
          this.timeoutMessage = "";
          this.email = email;
          this.token = token;
          this.page = "recover-with-token";
        }
      }, 1000);
    },

    async evOnTokenCanceled() {
      this.timeout = 5;
      this.timeoutMessage = `Token cancelado. Aguarde ${this.timeout} segundos para ser redirecionado.`;
      this.timeoutHandler = setInterval(() => {
        this.timeout--;
        this.timeoutMessage = `Token cancelado. Aguarde ${this.timeout} segundos para ser redirecionado.`;
        if (this.timeout <= 0) {
          clearInterval(this.timeoutHandler);
          this.timeoutMessage = "";
          this.$router.push({ name: "sign-in" });
        }
      }, 1000);
    },

    async evOnPasswordRecovered() {
      this.timeout = 5;
      this.timeoutMessage = `Senha atualizada. Aguarde ${this.timeout} segundos para ser redirecionado.`;
      this.timeoutHandler = setInterval(() => {
        this.timeout--;
        this.timeoutMessage = `Senha atualizada. Aguarde ${this.timeout} segundos para ser redirecionado.`;
        if (this.timeout <= 0) {
          clearInterval(this.timeoutHandler);
          this.timeoutMessage = "";
          this.$router.push({ name: "sign-in" });
        }
      }, 1000);
    },
  },
};
</script>

<style scoped>
/* Fundo com gradiente — idêntico ao SignIn para consistência visual */
.signin-page {
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #0F65B0 0%, #0F65B0 55%, #0F65B0 100%);
  overflow: hidden;
  z-index: 0;
}

/* SVG cobre toda a área, ícones em coordenadas absolutas no viewBox 1440×900 */
.signin-page__bg-icons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}

/* Eleva o card acima do SVG e adiciona sombra */
.signin-page__card.form-signin {
  position: relative;
  z-index: 1;
  border: none !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.28), 0 2px 8px rgba(0, 0, 0, 0.16);
  padding-bottom: 8px;
}

#logo {
  display: block;
  padding: 24px 32px 12px;
  width: 100%;
  height: auto;
  max-width: 300px;
  margin: 0 auto;
}
</style>